/*eslint-disable*/

import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';
const { PLACES_AUTOCOMPLETE_URL } = process.env;
import Autosuggest from 'react-autosuggest';
import { CitiesListMap } from './popularCitiesDataMap';

type city = {
  code: string;
  name: string;
  fullName: string;
};
type Suggestions = Suggestion[];
type Suggestion = {
  title: string;
  citieslist: city[];
};
type BusAutoCompleteProps = {
  cityCode?: string;
  placeholder: string;
  closeCityPopup: () => void;
  onChange: (city: string, code: string) => void;
};

const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const getSuggestions = async (value: string): Promise<Suggestions> => {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  const regex = new RegExp('^' + escapedValue, 'i');

  const response = await fetch(
    `${PLACES_AUTOCOMPLETE_URL}?query=${value}&version=v2&type=city&limit=10`
  )
    .then(r => r.json())
    .catch(e => []);

  var results = [
    {
      title: 'Error! Data not found',
      citieslist: [
        {
          code: '',
          name: '',
          fullName: ''
        }
      ]
    }
  ];

  if (response.success === true) {
    results = [
      {
        title: 'SEARCH RESULTS',
        citieslist: response.data.documents.map(city => ({
          code: city.id,
          name: city.n,
          fullName: city.dn
        }))
      }
    ];
  }

  return results;
};

const shouldRenderSuggestions = () => true;

const getSuggestionValue = (suggestion: city): string => suggestion.name;

const renderSuggestion = (suggestion: city, { query, isHighlighted }) => {
  var reg = new RegExp(query, 'gi');
  var org_str = suggestion.name;
  var final_str = org_str.replace(reg, function(str) {
    return '<span class="latoBlack">' + str + '</span>';
  });
  return (
    <div className="makeFlex column">
      <p className="searchedResult font16 darkGreyText">
        <span
          className="sr_iata grayText latoBold"
          dangerouslySetInnerHTML={{ __html: final_str }}
        ></span>
      </p>
      <p>
        <span className="sr_city">{suggestion.fullName}</span>{' '}
      </p>
    </div>
  );
};

const renderSectionTitle = (section: Suggestion) => (
  <p className="bsw_sectionTitle font12 latoBold grayText">{section.title}</p>
);

const getSectionSuggestions = (section: Suggestion) => section.citieslist;

const AutoComplete = ({
  cityCode = '',
  placeholder,
  closeCityPopup,
  onChange
}: BusAutoCompleteProps) => {
  const [value, setValue] = useState('');

  //use cities list if available else use default list from CitiesListMap
  const initialCitiesList = CitiesListMap[cityCode]
    ? CitiesListMap[cityCode]
    : CitiesListMap['default'];

  const [suggestions, setSuggestions] = useState<Suggestions>(
    initialCitiesList
  );
  let input;
  useEffect(() => {
    input.focus();
  });

  const onValueChange = (_, { newValue }) => {
    setValue(newValue);
  };

  const onSuggestionsFetchRequested = debounce(async ({ value }) => {
    //when input is empty use initialCitiesList
    if (value) {
      setSuggestions(await getSuggestions(value));
    } else {
      setSuggestions(initialCitiesList);
    }
  }, 200);

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    onChange(suggestion.name, suggestion.code);
    closeCityPopup();
  };

  const storeInputReference = autosuggest => {
    if (autosuggest !== null) {
      input = autosuggest.input;
    }
  };

  const inputProps = {
    placeholder,
    value,
    onChange: onValueChange
  };

  return (
    <div className="bsw_autocomplePopup">
      <div className="backArr" onClick={() => closeCityPopup()}>
        <span className="cm__leftArrow"></span>
      </div>
      <Autosuggest
        isHighlighted={true}
        multiSection={true}
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
        shouldRenderSuggestions={shouldRenderSuggestions}
        inputProps={inputProps}
        focusInputOnSuggestionClick={true}
        alwaysRenderSuggestions={true}
        ref={storeInputReference}
      />
    </div>
  );
};

export default AutoComplete;
